import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

const STAFF_PREFIXES = ['/admin', '/employee-portal'];

export default function GeoGate({ children }) {
  const location = useLocation();
  // Staff/owner tools (admin panel + employee portal) are NEVER geo-gated so the
  // owner and employees can always log in and run the shop from anywhere. Re-evaluated
  // on every route change so in-app navigation to a staff route is never blocked.
  const isStaffRoute = STAFF_PREFIXES.some((p) => location.pathname.startsWith(p));

  const [status, setStatus] = useState('checking'); // checking | allowed | blocked

  useEffect(() => {
    if (isStaffRoute) { setStatus('allowed'); return; }
    let cancelled = false;
    fetch(`${API_URL}/api/geo-check`, { cache: 'no-store' })
      .then(r => r.json())
      .then(data => { if (!cancelled) setStatus(data.allowed ? 'allowed' : 'blocked'); })
      .catch(() => { if (!cancelled) setStatus('allowed'); }); // fail-open so US users aren't accidentally blocked
    return () => { cancelled = true; };
  }, [isStaffRoute]);

  // Staff tools always render, even if a prior public page had set status='blocked'.
  if (isStaffRoute) return children;

  if (status === 'checking') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f172a' }}>
        <div style={{ width: 40, height: 40, border: '3px solid rgba(255,255,255,0.1)', borderTop: '3px solid #dc2626', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  if (status === 'blocked') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f172a', color: '#fff', fontFamily: 'Inter, system-ui, sans-serif', padding: '2rem', textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>2A Electronics</div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.75rem', color: '#f87171' }}>
          Service Unavailable in Your Region
        </h1>
        <p style={{ fontSize: '1rem', color: '#94a3b8', maxWidth: 480, lineHeight: 1.6 }}>
          2A Electronics is currently available only in the United States. We appreciate your interest and hope to expand in the future.
        </p>
      </div>
    );
  }

  return children;
}
